import { lazy } from 'react';

export const MainLazy = lazy(
  () => import('../../views/main/Main' /* webpackChunkName: "main" */ /* webpackPrefetch: true */),
);
export const SinglePageSwitchLazy = lazy(
  () =>
    import(
      '../../views/single-page-switch/SinglePageSwitch' /* webpackChunkName: "main" */ /* webpackPrefetch: true */
    ),
);
export const OrderConfirmationLazy = lazy(
  () => import('../../views/order-confirmation/OrderConfirmation' /* webpackChunkName: "orderConfirmation" */),
);
export const Auth0CallbackGuestLazy = lazy(
  () =>
    import('../../views/auth0-callback/Auth0CallbackGuest' /* webpackChunkName: "main" */ /* webpackPrefetch: true */),
);
export const Auth0CallbackAuthenticatedLazy = lazy(
  () =>
    import(
      '../../views/auth0-callback/Auth0CallbackAuthenticated' /* webpackChunkName: "main" */ /* webpackPrefetch: true */
    ),
);
export const Auth0CallbackOrderClaimLazy = lazy(
  () =>
    import(
      '../../views/auth0-callback/Auth0CallbackOrderClaim' /* webpackChunkName: "main" */ /* webpackPrefetch: true */
    ),
);
export const Auth0CallbackCreateAccountLazy = lazy(
  () =>
    import(
      '../../views/auth0-callback/Auth0CallbackCreateAccount' /* webpackChunkName: "main" */ /* webpackPrefetch: true */
    ),
);
export const AgeVerificationCallbackLazy = lazy(
  () => import('../../views/age/AgeVerificationCallback' /* webpackChunkName: "main" */ /* webpackPrefetch: true */),
);
